import React, { ReactNode } from 'react';

interface ButtonProps {
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  icon?: ReactNode;
  className?: string;
  target?: string;
  rel?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  href,
  onClick,
  variant = 'primary',
  icon,
  className = '',
  target,
  rel
}) => {
  const baseClasses = "px-8 py-4 rounded-xl font-bold text-lg transition-all flex items-center justify-center gap-2";
  
  const variantClasses = {
    primary: "bg-blue-600 text-white hover:bg-blue-700 shadow-xl shadow-blue-600/20",
    secondary: "bg-white text-slate-700 border border-slate-200 hover:bg-slate-50",
    outline: "bg-slate-800 border border-slate-700 text-white hover:bg-slate-700"
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} target={target} rel={rel}>
        {children}
        {icon}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={classes}>
      {children}
      {icon}
    </button>
  );
};
